/**
 * 開発時のみ出力するロガー。
 *
 * 認証・token まわりの debug ログが本番ビルドに残ると、
 * token の有無や prefix などの情報がコンソールに漏れる懸念がある。
 * 本番（NODE_ENV === 'production'）では log/debug/info を無効化し、
 * warn/error は障害調査のため残す。
 *
 * CRA は process.env.NODE_ENV をビルド時に定数置換するため、
 * 本番ビルドでは log/debug/info の呼び出しが実質デッドコードになる。
 */
const isProduction = process.env.NODE_ENV === 'production';

type LogArgs = unknown[];

export const logger = {
  log: (...args: LogArgs): void => {
    if (!isProduction) {
      // eslint-disable-next-line no-console
      console.log(...args);
    }
  },
  debug: (...args: LogArgs): void => {
    if (!isProduction) {
      // eslint-disable-next-line no-console
      console.debug(...args);
    }
  },
  info: (...args: LogArgs): void => {
    if (!isProduction) {
      // eslint-disable-next-line no-console
      console.info(...args);
    }
  },
  warn: (...args: LogArgs): void => {
    // eslint-disable-next-line no-console
    console.warn(...args);
  },
  error: (...args: LogArgs): void => {
    // eslint-disable-next-line no-console
    console.error(...args);
  },
};

export default logger;
